module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/coj_f-4-a584dbd495e4d87303768fb7ccf1c9b6.jpg";